import Utils from './utils';
import Listeners from './listeners';
import Emitters from "./emitters";
const Logger = require('js-logger');
import {constants, playMode} from "./constants";

import Api from './api';
import packageJson from '../package.json';
import Modal from "./utils/modal";
import 'whatwg-fetch'; // fetch polyfill
import LightNWonder from './wallet/LightNWonder';

export default class GameBridge {
    constructor(settings, hooks = {}) {
        //by default css file is not loaded
        this.cssLoaded = false;
        this.hooks = hooks;
        // exposed these for an inhouse tool helper
        // https://prodcopy-services.oryxgaming.com/games/O2X/O2X_ALG_EU/demo/iframe.html?mock=true
        this.constants = constants;

        this.init(settings);
        this.handleLoggerLevel(settings);
        this.initLogging()
        if (!settings.disablePostMessageTransmission === true) {
            this.setProtocols()
        }
        if (this.gameProviderCode === constants.HKS) {
            this.addIframeHKSGames()
        }
        else if (this.walletProtocol === constants.LNWOGS) {
            this.wallet = new LightNWonder(settings, this);
            this.gameIframe = this.wallet.addIframeLNWOGS();

            //in case of authenticate error
            if(settings.aggLaunchErrorData) {
                return;
            }
        } else if (this.gameProviderCode === constants.EGT && this.settings.nativeMobileApp) { 
            //for EGT on iOS we ned to call initHTML function after iFrame is loaded
            this.addIframeEGToniOS();
        } else if (settings.launchLink) {
            if (this.gameProviderCode === constants.HI5) {
                this.addIframeHI5Games()
            } else {
                this.addIframeToDom();
            }
        } else if (this.rgsProtocol) {
           this.addIframeWithRgsData();
        } else if (settings.gameSessionUrl && this.gameProviderCode === constants.STAKELOGIC) {
            this.addIframeWithGameSessionUrl();
        } else {
            logger.warn("No 'launchLink' or 'rgsData' provided via settings object passed to GameBridge ... GB will not create game frame. You should do it manually in the HTML code!");
        }

        this._registerGameSwitchHandler();

        //handle CMA message on launch
        if (settings.walletLaunchCMAMessage) {
            try {
                var message = JSON.parse(settings.walletLaunchCMAMessage);
                message.body = message.content;
                message.prohibitGameplay = false;
                var modal = new Modal( this.api, message, () => {
                    // this.api.gb.emitters.emit.game.resumeGame();
                });
    
                //open modal popup
                modal.showModal();
            } catch (error) {
                logger.error("Error displaying CMA popup.");
            }
        }

        if (this.queryParams.keepalive && this.queryParams.keepaliveUrl) {
            let keepaliveInterval = ~~this.queryParams.keepalive;
            if (isNaN(this.queryParams.keepalive) || keepaliveInterval <= 0) {
                logger.warn("no keepAlive call set up. 'keepAlive' param not set correctly. Should be integer bigger then 1 (milliseconds), got: ", this.queryParams.keepalive);
            } else {
                logger.info("setting up keepAlive interval", this.queryParams.keepaliveUrl, keepaliveInterval);
                this.setupKeepAlive(keepaliveInterval);
            }
        } else {
            logger.info("no keepAlive call set up. Missing 'keepalive' and/or 'keepaliveUrl' params");
        }

        window._gameBridge = this;

        if (this.gameProviderCode === constants.BP) {
            document.addEventListener('DOMContentLoaded', () => {
                window.addEventListener("resize",  ()=> {
                    setTimeout(()=> {
                        this.clientWidth = Math.max(document.body.clientWidth || 0, window.innerWidth || 0)
                        this.clientHeight = Math.max(document.body.clientHeight || 0, window.innerHeight || 0)
                        this.emitters.emit.game.resize();
                    },200)
                })
            })
        }

        if (this.walletProtocol === constants.GIG && this.gameProviderCode === constants.FBM) {
            this.emitters.emit.web.gameLoadEnd()
        }

        // hack
        // if (this.gameProviderCode === constants.EVOL && this.walletCode === constants.EXCITE) {
        //     this.keepAliveNumRetryIndex = 0;
        //     this.keepAliveNumRetry = this.settings.keepAliveNumRetry || 9999999999;
        //     this.keepAliveIntervalLength = this.settings.keepAliveIntervalLength || 840000;
        //
        //     setTimeout(() => {
        //         this.sendKeepAlivePostMsg();
        //     }, this.keepAliveIntervalLength);
        // }
    }

    init(settings) {

        this.logIndex = 0;
        this.version = packageJson.version.replace("1.0.0-", "");
        this.utils = new Utils(this, settings);
        this.uuid = "INCOGNITO_BROWSING";

        if (this.utils.isLocalStorageAvailable === true) {
            this.uuid = localStorage.gameBridgeUUID;
            if (!this.uuid) {
                this.uuid = this.utils.createUUID();
                localStorage.gameBridgeUUID = this.uuid;
            }
        }

        Object.assign(this, { settings, queryParams: this.utils.getQueryParams() });

        if (this.settings.logoutUrl) {
            this.queryParams.logoutUrl = this.settings.logoutUrl;
        }

        if (this.settings.gameProviderCode === constants.GTB) {
            const params = this.utils.getQueryParamsFullUrl(this.settings.launchLink);
            this.queryParams.freeRounds = params && params.FreeSpins === "True" ? true : false
        }

        if (this.settings.lobbyUrl) {
            this.queryParams.lobbyUrl = this.settings.lobbyUrl;
        }

        if (this.settings.numberOfHistoryBack) {
            this.queryParams.numberOfHistoryBack = this.settings.numberOfHistoryBack;
        }

        this.queryParams.rcBtnSetup = this.settings.rcBtnSetup ? this.settings.rcBtnSetup.toLocaleLowerCase() : constants.LOGOUT

        if (this.settings.playMode && this.settings.playMode === playMode.REAL) {
            if (this.settings.socketUrl) {
                this.api = new Api(this);
            } else {
                logger.warn("'socketUrl' not provided in settings object passed to GameBridge constructor - WebSocket to agg front server will not be opened!");
            }
        } else {
            logger.info("'playMode' is not 'REAL', so WebSocket will not be opened!");
        }
    }

    sendKeepAlivePostMsg() {
        this.emitters.emit.web.customMsg({"event":"keepAlive"});
        this.keepAliveNumRetryIndex++;

        if (this.keepAliveNumRetry > this.keepAliveNumRetryIndex) {
            setTimeout(() => {
                this.sendKeepAlivePostMsg();
            }, this.keepAliveIntervalLength);
        }
    }

    setLoggerLevel(level, serverPush) {
        Logger.setLevel(Logger[level]);

        // so that everything gets send to server
        this.settings.serverLoggerLevel = null;
        logger.info(`Logger level set to '${level}'.${serverPush === true ? ' Server push.' : ''}`);
    }

    setCurrencyCode(currencyCode) {
        this.settings.currencyCode = currencyCode;
    }

    setupKeepAlive(keepaliveInterval) {
        this.keepAliveInterval = setInterval(() => {
            logger.debug("KeepAlive OUT");

            let fetchOptions = {};

            if (this.queryParams.keepAliveWithCredentials === "true" || this.queryParams.keepAliveWithCredentials === true) {
                fetchOptions.credentials = 'include';
            }

            fetch(decodeURIComponent(this.queryParams.keepaliveUrl), fetchOptions)
                .then((r) => {
                    if (r && r.status && r.status >= 200 && r.status <= 299) {
                        return r.text();
                    } else {
                        throw r;
                    }
                })
                .then((data) => {
                    try {
                        data = JSON.parse(data);
                    } catch (e) {
                        // not a json
                    }
                    logger.debug("KeepAlive IN - all ok. Data returned: ", data);

                }).catch((e) => {
                    logger.error("KeepAlive IN - failed!", e);
            })
        }, keepaliveInterval);
    }

    addIframeToDom() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";

        //  if (!this.utils.isIframe) {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        // }
        
        this.gameIframe = document.createElement("iframe");
        this.gameIframe.src = (this.gameProviderProtocol === constants.EVP || this.settings.gameProviderCode === 'ENDOR' || this.settings.gameProviderCode === 'PGS') ? `${this.settings.launchLink}` : `${this.settings.launchLink}${this.settings.launchLink.indexOf("?") > -1 ? "&" : "?"}isGameBridge=true`;
        this.gameIframe.id = this.gameProviderProtocol === constants.NSOFT ? 'seven-plugin' : 'gameWindow';
        this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";

        if (this.gameProviderProtocol === constants.EGT) {
            this.gameIframe.allow = 'autoplay *; screen-wake-lock *; fullscreen *';
        }

        if (this.gameProviderProtocol === constants.EDIG) {
            this.gameIframe.allow = 'autoplay *; screen-wake-lock *;';
        }

        if (this.gameProviderProtocol === constants.PT) {
            this.gameIframe.src += '&integration=ucip'
        }

        if (this.settings.iframeAllowCamera) {
            this.gameIframe.allow = 'camera';
        }

        // this.gameIframe.height = "100vh";
        // this.gameIframe.setAttribute("allowfullscreen", "true");

        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            document.body.append(container);
        }

        document.querySelector("#gameContainer").style = `width: 100%; height: 100%`;
        if (this.settings.clientVersion) {
            this.gameIframe.style.display = 'block';
            this.gameIframe.style.height = 'calc(100% - 9px)';
            document.querySelector("#gameContainer").append(this.gameIframe);
            const gameVersion = document.createElement('div');
            gameVersion.style = "height:9px; font-size:8px; font-weight:normal; font-family:Arial,'Roboto',sans-serif; text-align:center; color:#7c7c7c; background: #000000;"
            gameVersion.innerText = this.settings.clientVersion
            document.querySelector("#gameContainer").append(gameVersion);
        } else {
            document.querySelector("#gameContainer").append(this.gameIframe);
        }

        logger.debug("Iframe with launchLink added to DOM");

        const userAgent = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : undefined;

        if (this.settings.autoFullScreenOnMobile && window.innerWidth < 1199 && userAgent && userAgent.match(/android/)) {
            this.utils.goToFullScreenAutomatic();

            document.onfullscreenchange =  () => {
                if (!document.fullscreenElement) {
                    document.getElementsByTagName("html")[0].style.position = "fixed";
                }
            };
        }

        if (userAgent && userAgent.match(/(ipod|iphone|ipad)/) && userAgent.match(/applewebkit/)) {
            window.onresize = () => {
                this.utils.changeOrientationCss();
            }
        }

        if (
            this.gameProviderCode === constants.NSOFT &&
            this.settings &&
            this.settings.iFrameResize
        ) {
            if (window.innerWidth < 769) {
                this.settings.iFrameResize({
                    autoResize: false,
                    checkOrigin: [this.settings.nsoftBaseUrl],
                    initCallback: (iframe)=> {
                        this.settings.iframe = iframe;
                        iframe.style.height  = window.innerHeight + "px";
                        window.addEventListener("resize", function(e) {
                            iframe.style.height  = window.innerHeight + "px";
                        })
                    },
                    messageCallback: (data) => {
                        if (data.message && data.message.type) {
                            switch (data.message.type) {
                                case 'contentLoaded':
                                    this.emitters.emit.web.gameLoadEnd();
                                    break;
                                case 'logout':
                                    this.emitters.emit.web.logout();
                                    break;
                                case 'logoutSuccess':
                                    this.emitters.emit.web.logoutSuccess();
                                    break;
                                case 'listenersReady':
                                    this.emitters.emit.web.listenersReady();
                                    break;
                                case 'loginRequired':
                                    this.emitters.emit.web.requestLogin();
                                    break;
                                case 'roundFinished':
                                    this.emitters.emit.web.gameRoundEnd();
                                    break;
                                case 'ticketResolved':
                                    this.emitters.emit.web.ticketResolved();
                                    break;
                            }
                        }
                    }
                });
            } else {
                this.settings.iFrameResize({
                    checkOrigin: [this.settings.nsoftBaseUrl],
                    initCallback: (iframe)=> {
                        this.settings.iframe = iframe
                    },
                    heightCalculationMethod: 'lowestElement',
                    messageCallback: (data) => {
                        if (data.message && data.message.type) {
                            switch (data.message.type) {
                                case 'contentLoaded':
                                    this.emitters.emit.web.gameLoadEnd();
                                    break;
                                case 'logout':
                                    this.emitters.emit.web.logout();
                                    break;
                                case 'logoutSuccess':
                                    this.emitters.emit.web.logoutSuccess();
                                    break;
                                case 'listenersReady':
                                    this.emitters.emit.web.listenersReady();
                                    break;
                                case 'loginRequired':
                                    this.emitters.emit.web.requestLogin();
                                    break;
                                case 'roundFinished':
                                    this.emitters.emit.web.gameRoundEnd();
                                    break;
                                case 'ticketResolved':
                                    this.emitters.emit.web.ticketResolved();
                                    break;
                            }
                        }
                    }
                });
            }
        }

        if (this.gameProviderProtocol === constants.PNG) {
            this.gameIframe.addEventListener('load', (e) => {
                this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "gameReady"})
                setTimeout(()=> {
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "roundStarted"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "roundEnded"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "gameReady"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "gameError"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "balanceUpdate"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "balance"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "reloadGame"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "logout"})
                    this.emitters.emit.game.customMsg({messageType: "addEventListener", eventType: "gameHistoryOpened"})
                },1000)
            });
        }

        if (this.gameProviderProtocol === constants.BP) {
            this.clientWidth = Math.max(document.body.clientWidth || 0, window.innerWidth || 0);
            this.clientHeight = Math.max(document.body.clientHeight || 0, window.innerHeight || 0);
        }

        if (this.walletProtocol === constants.INTRALOT && window.self === window.top) {
            let tries = 0;
            const maxTries = 10;

            const intervalId = setInterval(() => {
                if (tries >= maxTries || this.gameConfigReceived === true) {
            
                    clearInterval(intervalId);
                    
                    return;
                }
 
                this.emitters.emit.game.setGameConfig()

                tries++;
            }, 1000); 
        }
    }

    _registerGameSwitchHandler() {
        if (!this.settings.gbGameSwitchLaunchUrlTemplate) return;
        this._gameSwitchHandler = (e) => {
            let payload = e.data;
            if (typeof payload === "string") {
                try { payload = JSON.parse(payload); } catch (_) { return; }
            }
            if (!payload || payload.wpgaction !== "walletLaunchLinkSwap") return;
            this.openAnotherGame(payload);
        };
        window.addEventListener("message", this._gameSwitchHandler);
        logger.info("gbGameSwitchLaunchUrlTemplate present: walletLaunchLinkSwap message interceptor registered");
    }

    openAnotherGame(payload) {
        const template = this.settings && this.settings.gbGameSwitchLaunchUrlTemplate;
        const token = (this.settings && this.settings.token) || '';

        const gameChannels = payload && payload.data && payload.data.gameChannels;
        const gameCode = gameChannels && (
            (gameChannels.mobile && gameChannels.mobile.gameCode) ||
            (gameChannels.desktop && gameChannels.desktop.gameCode)
        );

        if (!template) {
            logger.warn("openAnotherGame: gbGameSwitchLaunchUrlTemplate is not configured");
            return;
        }
        if (!gameCode) {
            logger.warn("openAnotherGame: no gameCode in payload", payload);
            return;
        }

        const url = template
            .replace('${walletGameCode}', encodeURIComponent(gameCode))
            .replace('${token}', encodeURIComponent(token));

        logger.info("openAnotherGame: navigating to new game", { gameCode, url });

        // Since we're switching the game, we don't want to listen to the events anymore. There were some issues when the game was removed from the iframe,
        // and it sent close game event which caused the operator to close the iframe and the new game couldn't be loaded.
        this.listeners.destroy();
        window.location.href = url;
    }

    addIframeWithGameSessionUrl() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";

        if (!this.utils.isIframe) {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        }

        let container = document.createElement("div");
        container.id = "gameContainer";

        document.body.appendChild(container);

        const game = document.createElement("gcw-game");
        game.setAttribute('gcw-server-url', `${this.settings.gameSessionUrl}`);
        game.setAttribute('gcw-options', 'triggerThirdPartyEvent');
        game.id = 'gameWindow';
        game.style = "width: 100%; height: 100% !important; border: none;";

        let scriptTag = document.createElement('script');
        scriptTag.setAttribute('charset',"utf-8");
        scriptTag.setAttribute('type',"text/javascript");
        scriptTag.setAttribute('src',this.settings.gameClientJsLibUrl);
        scriptTag.setAttribute('id','gameClientJsLibUrl');

        const scriptTagBody = document.createElement('script');

        scriptTagBody.append(`
                let scrTag = document.getElementById('gameClientJsLibUrl');
      
                scrTag.onload = () => { 
                    function gameEventListener(type, data) {
                       
                        // if (type === gcw.api.GameEventType.HOME) {
                        // 
                        //     if (window.self !== window.top) {
                        //         window.top.postMessage({message: "close", param: null}, "*");
                        //     } else {
                        //         window.history.go(-2);
                        //     }
                        // }
                        if (type === gcw.api.GameEventType.REGISTER) {
                            this.gb.emitters.emit.web.requestRegister();
                        }
                        if (type === gcw.api.GameEventType.CASHIER) {
                            this.gb.emitters.emit.web.openCashier();
                        }
                        if (type === gcw.api.GameEventType.ERROR) {
                            this.gb.emitters.emit.web.error(data);
                        }
                        if (type === gcw.api.GameEventType.ROUND_START) {
                            this.gb.emitters.emit.web.gameSpinStart(data);
                        }
                        if (type === gcw.api.GameEventType.ROUND_END) {
                            this.gb.emitters.emit.web.gameSpinEnd(data);
                        }
                        if (type === gcw.api.GameEventType.RESULTS_SHOWN) {
                            this.gb.emitters.emit.web.resultsShown(data);
                        }
                        if (type === gcw.api.GameEventType.HOME) {
                            this.gb.emitters.emit.web.closeGame();
                        }
                    };
                    gcw.gameElementsInit(gameEventListener);
                };
        `)

        document.querySelector("#gameContainer").style = `width: 100%; height: 100%; border: none`;
        document.querySelector("#gameContainer").append(game);
        document.querySelector("#gameContainer").append(scriptTag);
        document.querySelector("#gameContainer").append(scriptTagBody);

        logger.debug("Iframe with gcw link added to DOM");

        if (this.settings.autoFullScreenOnMobile && !this.utils.isIframe) {
            const userAgent = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : null;

            if (userAgent.indexOf("android") > -1) {
                this.utils.goToFullScreenAutomatic()
            }
            // document.onfullscreenchange = function ( event ) {
            //     document.querySelector("#gameContainer").style.setProperty('min-height', '100vh')
            // };
        }
    }

    addIframeWithRgsData() {
        switch (this.rgsProtocol) {
            case constants.NLCNLC:
                this.addIframeNLCNLC();
                break;
            case constants.NETEBLUE:
                this.addIframeNETEBLUE();
                break;
            case constants.NETENETE:
                this.addIframeNETEBLUE();
                break;
            default:
                this.addIframeNETEBLUE();
        }
    }

    addIframeHI5Games() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";

        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            container.style.width = '100%';
            container.style.height = '100%';
            document.body.append(container);
        }

        let scriptTag = document.createElement('script');
        let metaTag = document.createElement('meta');
        
        scriptTag.setAttribute('src',this.settings.highFiveLibraryLink);
        scriptTag.setAttribute('async', 'async');
        scriptTag.setAttribute('defer', 'defer');
        metaTag.setAttribute('http-equiv',"Content-Security-Policy");
        metaTag.setAttribute('content',"upgrade-insecure-requests");

        document.head.appendChild(scriptTag);
        document.head.appendChild(metaTag);

        this.gameIframe = document.createElement("iframe");
        this.gameIframe.src = this.settings.launchLink;
        this.gameIframe.id = 'game-iframe';
        this.gameIframe.sandbox = 'allow-same-origin allow-scripts';
        this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";

        document.querySelector("#gameContainer").append(this.gameIframe);

        let _api;
        window.high5AsyncInit = (api, Events) => {
            const gameWindow = document.getElementById("game-iframe").contentWindow;
            api.init(window, gameWindow)
            _api = api

            // NAVIGATION EVENTS
            api.addEventListener(Events.GameEventType.Navigation,  (event) => {
                switch (event.navigationTarget) {
                    case Events.NavigationTarget.Cashier:
                        this.emitters.emit.web.openCashier();
                        break;
                    case Events.NavigationTarget.Exit:
                        this.emitters.emit.web.closeGame();
                        break;
                    case Events.NavigationTarget.History:
                        this.emitters.emit.web.gameHistory();
                        break;
                }
            })

            // game to web events
            api.addEventListener(Events.GameEventType.LoadingStarted, () => {
                this.emitters.emit.web.gameLoadStart();
            });
            api.addEventListener(Events.GameEventType.LoadingCompleted, () => {
                this.emitters.emit.web.gameLoadEnd();
            });
            api.addEventListener(Events.GameEventType.SpinStarted, () => {
                this.emitters.emit.web.gameSpinStart();
            });
            api.addEventListener(Events.GameEventType.SpinEnded, () => {
                this.emitters.emit.web.gameSpinEnd();
            });
            api.addEventListener(Events.GameEventType.BalanceUpdate, (e) => {
                this.emitters.emit.web.balanceChange(e);
            });
            api.addEventListener(Events.GameEventType.Error, () => {
                this.emitters.emit.web.error();
            });
        }
        // web to game events
        window.addEventListener('message', (msg) => {
            if (msg.data) {
                switch (msg.data.cmd) {
                    case 'hi5_pause':
                        _api.pause(msg.data.value)
                        break;
                    case 'hi5_mute':
                        _api.mute(msg.data.value)
                        break;
                    case 'hi5_reload_balance':
                        _api.reloadBalance()
                        break;
                }
            }
        })
    }

    addIframeHKSGames() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";


        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            container.style.width = '100%';
            container.style.height = '100%';
            document.body.append(container);
        }

        let scriptTag = document.createElement('script');
        if (this.settings.hksLibUrl) {
            scriptTag.setAttribute('src',this.settings.hksLibUrl);
        }

        document.head.appendChild(scriptTag);

        this.gameIframe = document.createElement("iframe");
        this.gameIframe.id = 'game';
        this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";

        document.querySelector("#gameContainer").append(this.gameIframe);

        const hacksawConfig = {
            gameid: this.settings.gameid,
            channel: this.settings.channel,
            token: this.settings.tokenHacksaw,
            language: this.settings.language,
            currency: this.settings.currency,
            partner: this.settings.partner,
            mode: this.settings.mode,
            lobbyurl: this.settings.lobbyurl,
            integrateorigin: this.settings.integrateorigin,
            iniframe: true,
            branding: this.settings.branding,
        };
        scriptTag.onload = function () {
            hacksaw.include('game', hacksawConfig)
        }
    }

    addIframeEGToniOS() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";

        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            container.style.width = '100%';
            container.style.height = '100%';
            document.body.append(container);
        }
        this.gameIframe = document.createElement("iframe");
        this.gameIframe.src = `${this.settings.launchLink}${this.settings.launchLink.indexOf("?") > -1 ? "&" : "?"}isGameBridge=true`;
        //this.gameIframe.src = 'https://portal-prodcopy.oryxgaming.com/appgames/hubtest/BRAGG_LOADER/../RORJSlot/index.html?&mediaUrl=https://portal-prodcopy.oryxgaming.com/appgames/hubtest/BRAGG_LOADER/../RORJSlot/game/&isGameBridge=true';
        this.gameIframe.id = 'gameWindow';
        this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";

        document.querySelector("#gameContainer").append(this.gameIframe);

        this.gameIframe.onload = () => {
            this.gameIframe.contentWindow.initHtml(JSON.stringify(this.settings.launchData));
        }
    }

    addIframeNETEBLUE() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";


        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";

            document.body.append(container);
        }

        document.querySelector("#gameContainer").style = `width: 100%; height: 100%`;

        let scriptTag = document.createElement('script');
        let metaTag = document.createElement('meta');
        let idDiv = document.createElement('div');

        idDiv.setAttribute('id', 'netentgame');
        scriptTag.setAttribute('src',this.settings.rsgData.gameInclusionUrl);
        metaTag.setAttribute('http-equiv',"Content-Security-Policy");
        metaTag.setAttribute('content',"upgrade-insecure-requests");

        document.head.appendChild(scriptTag);
        document.head.appendChild(metaTag);

        document.querySelector("#gameContainer").append(idDiv);

        const startGame = () => {
            const config = this.settings.rsgData;
            const success = (netEntExtend) => {
                netEntExtend.addEventListener("gameReady", () => {
                    this.gameIframe = document.getElementById("netentgame");
                    this.listeners = new Listeners(this);
                    this.emitters = new Emitters(this);
                    this.netEntExtendRef = netEntExtend;
                    this.emitters.emit.web.gameLoadEnd();
                });

                netEntExtend.addEventListener("audioToggle",  (msg) => {
                    if (msg) {
                        this.emitters.emit.web.soundOn();
                    } else {
                        this.emitters.emit.web.soundOff();
                    }
                });

                // netEntExtend.addEventListener("paytableToggle",  (msg) => {
                //     if (msg) {
                //         this.emitters.emit.web.openCashier();
                //     }
                // });

                netEntExtend.addEventListener("balanceChanged",  () => {
                    netEntExtend.get("balanceInCents",  (balance) => {
                            this.emitters.emit.web.balanceChange(balance);
                        }
                    );
                });

                netEntExtend.addEventListener("gameError",  (msg) => {
                    this.emitters.emit.web.error(msg);
                });

                netEntExtend.addEventListener("gameRoundStarted",  () => {
                    this.isSpinning = true;
                    this.emitters.emit.web.gameSpinStart();
                });

                netEntExtend.addEventListener("gameRoundEnded",  () => {
                    this.isSpinning = false;
                    this.emitters.emit.web.gameSpinEnd();

                    this.emitters.emit.web.keepAlive();
                });

                netEntExtend.addEventListener("goToLobby",  () => {
                    this.emitters.emit.web.closeGame();
                });

                logger.debug("Iframe added to DOM, rgsData game launch");
            };
            const error = function (e) {};

            netent.launch(config, success, error);
        };
        window.onload = startGame;
    }

    addNLCNLCIframeToDom() {
        document.getElementsByTagName("html")[0].style.height = "100%";
        document.getElementsByTagName("html")[0].style.width = "100%";
        document.getElementsByTagName("body")[0].style.height = "100%";
        document.getElementsByTagName("body")[0].style.width = "100%";
        document.getElementsByTagName("html")[0].style.padding = "0";
        document.getElementsByTagName("body")[0].style.padding = "0";
        document.getElementsByTagName("html")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.margin = "0";
        document.getElementsByTagName("body")[0].style.overflow = "hidden";

        // launchLink from documentation with game and operator params

        if (this.settings.rgsData && this.settings.rgsData.jurisdiction) {
            this.settings.rgsData.jurisdiction = encodeURIComponent(JSON.stringify(this.settings.rgsData.jurisdiction));
            this.settings.launchLink = `${this.settings.rgsData.productionEnvironment}loader/game-loader.html?game=${this.settings.rgsData.game}&operator=${this.settings.rgsData.operator}&token=${this.settings.rgsData.token}&device=${this.settings.rgsData.device}&jurisdiction=${this.settings.rgsData.jurisdiction}`
        } else {
            this.settings.launchLink = `${this.settings.rgsData.productionEnvironment}loader/game-loader.html?game=${this.settings.rgsData.game}&operator=${this.settings.rgsData.operator}&token=${this.settings.rgsData.token}&device=${this.settings.rgsData.device}`
        }

        this.gameIframe = document.createElement("iframe");
        this.gameIframe.src = `${this.settings.launchLink}${this.settings.launchLink.indexOf("?") > -1 ? "&" : "?"}isGameBridge=true`;
        this.gameIframe.id = 'gameWindow';
        this.gameIframe.style = "width: 100%; height: 100% !important; border: none;";

        if (this.settings.iframeAllowCamera) {
            this.gameIframe.allow = 'camera';
        }

        let container = document.querySelector("#gameContainer");

        if (!container) {
            container = document.createElement("div");
            container.id = "gameContainer";
            document.body.append(container);
        }

        document.querySelector("#gameContainer").style = `width: 100%; height: 100%`;
        if (this.settings.clientVersion) {
            this.gameIframe.style.display = 'block';
            this.gameIframe.style.height = 'calc(100% - 9px)';
            document.querySelector("#gameContainer").append(this.gameIframe);
            const gameVersion = document.createElement('div');
            gameVersion.style = "height:9px; font-size:8px; font-weight:normal; font-family:Arial,'Roboto',sans-serif; text-align:center; color:#7c7c7c; background: #000000;"
            gameVersion.innerText = this.settings.clientVersion
            document.querySelector("#gameContainer").append(gameVersion);
        } else {
            document.querySelector("#gameContainer").append(this.gameIframe);
        }

        logger.debug("NLCNLC Iframe with launchLink added to DOM");

        const userAgent = navigator && navigator.userAgent ? navigator.userAgent.toLowerCase() : undefined;

        if (this.settings.autoFullScreenOnMobile && window.innerWidth < 1199 && userAgent && userAgent.match(/android/)) {
            this.utils.goToFullScreenAutomatic();

            document.onfullscreenchange =  () => {
                if (!document.fullscreenElement) {
                    document.getElementsByTagName("html")[0].style.position = "fixed";
                }
            };
        }

        if (userAgent && userAgent.match(/(ipod|iphone|ipad)/) && userAgent.match(/applewebkit/)) {
            window.onresize = () => {
                this.utils.changeOrientationCss();
            }
        }
    }

    addIframeNLCNLC() {
        // we need to add this setting to settings to differentiate between loaders ( game-loader || rgs gameInclusionUrl )
        if (this.settings && this.settings.rgsData && this.settings.rgsData.productionEnvironment) {
            this.addNLCNLCIframeToDom()
        } else {
            document.getElementsByTagName("html")[0].style.height = "100%";
            document.getElementsByTagName("html")[0].style.width = "100%";
            document.getElementsByTagName("body")[0].style.height = "100%";
            document.getElementsByTagName("body")[0].style.width = "100%";
            document.getElementsByTagName("html")[0].style.padding = "0";
            document.getElementsByTagName("body")[0].style.padding = "0";
            document.getElementsByTagName("html")[0].style.margin = "0";
            document.getElementsByTagName("body")[0].style.margin = "0";

            let container = document.querySelector("#gameContainer");

            if (!container) {
                container = document.createElement("div");
                container.id = "gameContainer";

                document.body.append(container);
            }

            document.querySelector("#gameContainer").style = `width: 100%; height: 100%`;
            const scriptTag = document.createElement('script');
            const metaTag = document.createElement('meta');

            scriptTag.setAttribute('src',this.settings.rgsData.gameInclusionUrl);
            metaTag.setAttribute('http-equiv',"Content-Security-Policy");
            metaTag.setAttribute('content',"upgrade-insecure-requests");

            document.head.appendChild(scriptTag);
            document.head.appendChild(metaTag);

            function openGame(e) {
                const config = this.settings.rgsData;
                const gameElement = document.getElementById('gameContainer');

                const configObj = {
                    game: config.game,
                    target: gameElement,
                    operator: config.operator,
                    device: config.device,
                    language: config.language,
                    environment: config.environment,
                    fullscreen: false,
                    ...(config.token && { token: config.token}),
                    ...(config.autoplay !== undefined && { autoplay: config.autoplay}),
                    ...(config.gameInclusionUrl && { gameInclusionUrl: config.gameInclusionUrl})
                }

                let game = nolimit.load(configObj);
                this.nlcExtendRef = game

                this.listeners = new Listeners(this);
                this.emitters = new Emitters(this);

                game.on('ready', () => {
                    this.emitters.emit.web.gameLoadEnd();
                });

                game.on('idle', () => {
                    this.emitters.emit.web.gameSpinEnd();
                });

                game.on('busy', (e) => {
                    this.emitters.emit.web.gameSpinStart();
                });

                game.on('balance', (balance) => {
                    this.emitters.emit.web.balanceChange(balance);
                });

                game.on('deposit',  () => {
                    this.emitters.emit.web.openCashier();
                });

                game.on('accountHistory', () => {
                    this.emitters.emit.web.gameHistory();
                });

                game.on('error', (msg) => {
                    this.emitters.emit.web.error(msg);
                });

                game.on('exit', () => {
                    this.emitters.emit.web.closeGame();
                });
            }
            window.onload = openGame.bind(this);
        }
    }

    handleLoggerLevel(settings) {
        this.loggerLevel = "WARN";  // TRACE = 1, DEBUG = 2, INFO = 3, WARN = 5, ERROR = 8, OFF = 99
        if (settings.loggerLevel) {
            this.loggerLevel = settings.loggerLevel;
        }
        if (this.queryParams.loggerLevel) {
            this.loggerLevel = this.queryParams.loggerLevel;
        }
        Logger.useDefaults({
            defaultLevel: Logger[this.loggerLevel]
        });
        const consoleHandler = Logger.createDefaultHandler({
            formatter: function (messages, context) {
                messages.unshift("GameBridge: " + context.level.name);
            }
        });

        Logger.setHandler((messages, context) => {
            consoleHandler(messages, context);

            if (!this.api) {
                // no storing of logs to localStorage, if socket is not intended to be used ... this would simply fill the localStorage (max 5MB) if logs are never send to server (and cleard from localStorage)
                return;
            }

            const prioritys = ["TRACE", "DEBUG", "INFO", "WARN", "ERROR", "OFF"];

            if (this.settings.serverLoggerLevel) {
                let logLevel = prioritys.indexOf(context.level.name),
                    serverFilterLevel = prioritys.indexOf(this.settings.serverLoggerLevel);
                if (logLevel < serverFilterLevel) {
                    return;
                }
            }

            let log = [];
            for (let i = 0, max = messages.length; i < max; i++) {
                log.push(messages[i]);
            }

            if (this.settings.nativeMobileApp) {
                setTimeout(() => {
                    this.api.comm.nativeAppLog({ prio: prioritys.indexOf(context.level.name), log: log });
                }, 300)
            }

            // if in incognito mode, or full, or nativeMobileApp then dont push more stuff in it ... will cause error ...
            if (this.utils.isLocalStorageAvailable === false) return;

            // Store log to localHost so that interval function will send it to server
            localStorage[`clientLog_${+new Date()}_${this.logIndex++}_${context.level.name}`] = JSON.stringify(log);
        });
    }


    initLogging() {
        if (this.utils.isLocalStorageAvailable === false) {
            logger.warn("LocalStorage unavailable.");
        }

        logger.info(`Logger level set to '${this.loggerLevel}'.`);
        logger.info("userAgent", window.navigator.userAgent);
        logger.debug("Settings passed to GameBridge:", this.settings);
        logger.debug("Query params passed to GameBridge via Aggregator link:", this.queryParams);
    }

    setProtocols() {
        this.gameProviderCode = this.settings.gameProviderCode ? this.settings.gameProviderCode.toUpperCase().replace(/-/g, "_") : null;
        this.setGameProtocol();
        this.walletCode = this.settings.walletCode ? this.settings.walletCode.toUpperCase().replace(/-/g, "_") : null;
        this.setWalletProtocol();
        const gameRgs = ['NYX','EVOL']
        if (this.settings.rgsProviderCode && gameRgs.includes(this.settings.rgsProviderCode)) {
            this.rgsProviderCode = this.settings.rgsProviderCode.toUpperCase().replace(/-/g, "_");
            this.setGameWithRgsProtocol();
        } else if (this.settings.rgsProviderCode) {
            this.rgsProviderCode = null;
            this.rgsProviderCode = this.settings.rgsProviderCode.toUpperCase().replace(/-/g, "_");
            this.setRgsProtocol();
        }
        //Spingames for Playtech wallet integration already emit Playtech events
        if (this.gameProviderProtocol === constants.SPIN && this.walletProtocol === constants.PLAYTECH) {
            this.passThrough2Playtech = true;
        }


        if (!this.rgsProtocol ||
            (this.rgsProtocol === 'NLC_NLC' && this.settings && this.settings.rgsData && this.settings.rgsData.productionEnvironment)) {
            this.emitters = new Emitters(this);
            this.listeners = new Listeners(this);
        }
    }

    setWalletProtocol() {
        switch (this.walletCode) {
            case null:
            case constants.ORYX:
            case constants.ORYX_WS:
                this.walletProtocol = constants.ORYX;
                break;
            case constants.EXCITE:
                this.walletProtocol = constants.EXCITE;
                break;
            case constants.LOTTOLAND:
                this.walletProtocol = constants.LOTTOLAND;
                break;
            case constants.SBTECH:
                this.walletProtocol = constants.SBTECH;
                break
            case constants.MGS:
                this.walletProtocol = constants.MGS;
                break;
            case constants.NSOFT:
                this.walletProtocol = constants.NSOFT;
                break
            case constants.GIG:
                this.walletProtocol = constants.GIG;
                break;
            case constants.SPINGAMES:
            case constants.RSI:
            case constants.DKG:
            case constants.GAN:
            case constants.SGD:
            case constants.PALA:
                this.walletProtocol = constants.SPINGAMES;
                break;
            case constants.GAMEIOM:
                this.walletProtocol = constants.GAMEIOM;
                break;
            case constants.BWIN:
                this.walletProtocol = constants.BWIN;
                break;
            case constants.PLAYTECH:
            case constants.SPIN2PLAYTECH:
                this.walletProtocol = constants.PLAYTECH;
                break;
            case constants.BETCONSTRUCT:
                this.walletProtocol = constants.BETCONSTRUCT;
                break;
            case constants.COMEON:
                this.walletProtocol = constants.COMEON;
                break;
            case constants.POKERSTARS:
                this.walletProtocol = constants.POKERSTARS;
                break;
            case constants.CAESARSCASINONJ:
            case constants.CAESARSCASINOPA:
            case constants.CAESARSMI:
            case constants.CAESARSNJ:
            case constants.CAESARSON:
            case constants.CAESARSPA:
            case constants.CAESARSWV:
            case constants.CAESARS:
                this.walletProtocol = constants.CAESARS;
                break;
            case constants.LNWOGS:
                this.walletProtocol = constants.LNWOGS;
                break;
            case constants.VEGASSOFTWARE:
                this.walletProtocol = constants.VEGASSOFTWARE;
                break;
            case constants.INTRALOT:
                    this.walletProtocol = constants.INTRALOT;
                    break;
            case constants.SOFTSWISS:
            case constants.SOFTSWISS2:
                this.walletProtocol = constants.SOFTSWISS;
                break;
            default:
                this.walletProtocol = constants.DEFAULT;
        }

        logger.info("Using wallet protocol:", this.walletProtocol);
    }

    setGameWithRgsProtocol() {
        switch(`${this.rgsProviderCode}_${this.gameProviderCode}`) {
            case constants.NYXNEXTGEN:
            case constants.NYXSG:
            case constants.NYXBDG:
            case constants.NYXBTG:
            case constants.NYXTHUNDER:
                this.gameProviderProtocol = constants.NYXNEXTGEN;
                break;
            case constants.EVOLBTG:
            case constants.EVOLNETE:
            case constants.EVOLRTG:
            case constants.EVOLNLC:
            case constants.EVOLEZUGI:
            case constants.EVOLEVOL:
                this.gameProviderProtocol = constants.EVOLUTION
                break;
            default:
                this.gameProviderProtocol = constants.DEFAULT;
        }
    }

    setGameProtocol() {
        switch (this.gameProviderCode) {
            case null:
            case constants.ORYX:
            case constants.GAM:
            case constants.GIVME:
            case constants.KLM:
            case constants.GHG:
            case constants.ASL:
            case constants.CDB:
            case constants.PSO:
            case constants.ARC:
            case constants.O2X:
            case constants.BLG:
            case constants.GMT:
            case constants.BBR:
            case constants.APL:
                this.gameProviderProtocol = constants.ORYX;
                break;
            case constants.FOL:
                this.gameProviderProtocol = constants.FOL;
                break;
            case constants.AMATIC:
                this.gameProviderProtocol = constants.AMATIC;
                break;
            case constants.EVOL:
            case constants.EVOLUTION:
                this.gameProviderProtocol = constants.EVOLUTION;
                break;
            case constants.PP:
                this.gameProviderProtocol = constants.PRAGMATIC_PLAY;
                break;
            case constants.F1X2:
                this.gameProviderProtocol = constants.F1X2;
                break;
            case constants.SLG:
                this.gameProviderProtocol = constants.SLINGO;
                break;
            case constants.GTB:
                this.gameProviderProtocol = constants.GREENTUBE;
                break;
            case constants.RELAX:
            case constants.SW:
            case constants.BTG:
            case constants.GVY:
            case constants.SBLT:
                this.gameProviderProtocol = constants.RELAX;
                break;
            case constants.PUSH:
                this.gameProviderProtocol = constants.PUSH;
                break;
            case constants.IGT:
                this.gameProviderProtocol = constants.IGT;
                break;
            case constants.PNG:
                this.gameProviderProtocol = constants.PNG;
                break
            case constants.MGS:
                this.gameProviderProtocol = constants.MGS;
                break;
            case constants.NETE:
                this.gameProviderProtocol = constants.NETE;
                break
            case constants.NEXTGEN:
                this.gameProviderProtocol = constants.NEXTGEN;
                break;
            case constants.THUNDER:
                this.gameProviderProtocol = constants.THUNDER;
                break;
            case constants.BP:
                this.gameProviderProtocol = constants.BP;
                break;
            case constants.EGT:
            case constants.AMUS: // Game provider AMUS (Amusnet) is used for EGT games served through G1 (Gaming1) RGS. Game events are the same as for EGT games (games are the same).
                this.gameProviderProtocol = constants.EGT;
                break;
            case constants.NLC:
                this.gameProviderProtocol = constants.NLC;
                break;
            case constants.EDICT:
                this.gameProviderProtocol = constants.EDICT;
                break;
            case constants.EZUGI:
                this.gameProviderProtocol = constants.EZUGI;
                break;
            case constants.NSOFT:
                this.gameProviderProtocol = constants.NSOFT;
                break;
            // case constants.GSBINGO:
            //     this.gameProviderProtocol = constants.GSBINGO;
            //     break;
            case constants.GSPOKER:
                this.gameProviderProtocol = constants.GSPOKER;
                break;
            case constants.STAKELOGIC:
                this.gameProviderProtocol = constants.STAKELOGIC;
                break;
            case constants.STAKELOGIC2:
                this.gameProviderProtocol = constants.STAKELOGIC2;
                break;
            case constants.SH:
                this.gameProviderProtocol = constants.SH;
                break;
            case constants.DGC:
                this.gameProviderProtocol = constants.DGC;
                break;
            case constants.BGS:
                this.gameProviderProtocol = constants.BGS;
                break;
            case constants.RGU:
                this.gameProviderProtocol = constants.RGU;
                break;
            case constants.RAW:
                this.gameProviderProtocol = constants.RAW;
                break;
            case constants.HB:
                this.gameProviderProtocol = constants.HB;
                break;
            case constants.QS:
                this.gameProviderProtocol = constants.QS;
                break;
            case constants.RRG:
                this.gameProviderProtocol = constants.RRG;
                break;
            case constants.FAZI:
                this.gameProviderProtocol = constants.FAZI;
                break;
            case constants.EVP:
                this.gameProviderProtocol = constants.EVP;
                break;
            case constants.WD:
                this.gameProviderProtocol = constants.WD;
                break;
            case constants.WZD:
                this.gameProviderProtocol = constants.WZD;
                break;
            case constants.SPRIBE:
                this.gameProviderProtocol = constants.SPRIBE;
                break;
            case constants.HI5:
                this.gameProviderProtocol = constants.HI5;
                break;
            case constants.HKS:
                this.gameProviderProtocol = constants.HKS;
                break;
            case constants.SYN:
                this.gameProviderProtocol = constants.SYN;
                break;
            case constants.KAJ:
                this.gameProviderProtocol = constants.KAJ;
                break;
            case constants.DUSO:
                this.gameProviderProtocol = constants.DUSO;
                break;
            case constants.ISOFT:
                this.gameProviderProtocol = constants.ISOFT;
                break;
            case constants.SWT:
                this.gameProviderProtocol = constants.SWT;
                break;
            case constants.RST:
                this.gameProviderProtocol = constants.RST;
                break;
            case constants.PT:
                this.gameProviderProtocol = constants.PT;
                break;
            case constants.YGG:
            case constants.YAT:
                this.gameProviderProtocol = constants.YGG;
                break;
            case constants.ZITRO:
                this.gameProviderProtocol = constants.ZITRO;
                break;
            case constants.BFG:
                this.gameProviderProtocol = constants.BFG;
                break;
            case constants.HBN:
                this.gameProviderProtocol = constants.HBN;
                break;
            case constants.ENDOR:
                this.gameProviderProtocol = constants.ENDOR;
                break;
            case constants.SPIN:
            case constants.IT:
            case constants.GLX:
            case constants.FSLV:
            case constants.GLAB:
            case constants.GVG:
            case constants.WS2:
            case constants.EI:
            case constants.EBC:
                this.gameProviderProtocol = constants.SPIN;
                break;
            case constants.PLS:
                this.gameProviderProtocol = constants.PLS;
                break;
            case constants.KIRON:
                this.gameProviderProtocol = constants.KIRON;
                break;
            case constants.GDR2:
            case constants.GDR2HTV:
            case constants.GDR2SMT:
                this.gameProviderProtocol = constants.GDR2;
                break;
            case constants.BETGAMESTV:
                this.gameProviderProtocol = constants.BETGAMESTV;
                break;
            case constants.SPINOMENAL:
                this.gameProviderProtocol = constants.SPINOMENAL;
                break;
            case constants.BGM:
                this.gameProviderProtocol = constants.BGM;
                break;
            case constants.STT:
                this.gameProviderProtocol = constants.STT;
                break;
            case constants.SSG:
                this.gameProviderProtocol = constants.SSG;
                break;
            case constants.EDIG:
                this.gameProviderProtocol = constants.EDIG;
                break;
            case constants.T4B:
                this.gameProviderProtocol = constants.T4B;
                break;
            case constants.EYE:
                this.gameProviderProtocol = constants.EYE;
                break;
            case constants.HNR:
                this.gameProviderProtocol = constants.HNR;
                break;
            case constants.OAK:
                this.gameProviderProtocol = constants.OAK;
                break;
            case constants.BSFT:
                this.gameProviderProtocol = constants.BSFT;
                break;
            case constants.PATE:
                this.gameProviderProtocol = constants.PATE;
                break;
            case constants.BOOMING:
                this.gameProviderProtocol = constants.BOOMING;
                break;
            default:
                this.gameProviderProtocol = constants.DEFAULT;
        }


        logger.info("Using game provider protocol:", this.gameProviderProtocol);
    }

    setRgsProtocol() {
        switch (this.settings.rgsProviderCode + "_" + this.settings.gameProviderCode) {
            case constants.NETEBLUE:
                this.rgsProtocol = constants.NETEBLUE;
                break;
            case constants.NETENETE:
                this.rgsProtocol = constants.NETENETE;
                break;
            case constants.NLCNLC:
                this.rgsProtocol = constants.NLCNLC;
                break;
            default:
                this.rgsProtocol = undefined;
        }

        logger.info("Using rgs protocol:", this.rgsProtocol);
    }
}
